import { linkedToTypes } from 'modules/documents/constants/linkedToTypes';

type GetLinkedToProps = {
  partnerId?: string;
  operationId?: string;
};

type LinkedTo = {
  linkedId: string;
  linkedType: string;
};

export const getLinkedTo = ({
  partnerId,
  operationId,
}: GetLinkedToProps): LinkedTo[] => {
  const linkedTo = [];

  if (partnerId) {
    linkedTo.push({
      linkedId: partnerId,
      linkedType: linkedToTypes.PARTNER,
    });
  }
  if (operationId) {
    linkedTo.push({
      linkedId: operationId,
      linkedType: linkedToTypes.OPERATION,
    });
  }

  return linkedTo;
};
